import { Link, useNavigate, useParams } from "react-router-dom";
import { BreadCrumb } from "../../../Layout/Common/breadCrumb";
import React, { useEffect, useRef, useState } from "react";
import { useNoteAlert } from "../../../Context/pleaseNote";
import { CHANGEUSERNAME } from "../../../constants";
import { useAuth } from "../../../Context/AuthContext";
import { axiosInstance } from "../../../axios/axiosInstance";
import { isAlphaNumericAnd_dot } from "../../../Layout/Common/common";
import $ from "jquery";
import { CancelButton } from "../../../Layout/Common/cancelButton";
import { PAGES } from "../../../routeConfig";
export const ChangeUsername = () => {
  const [txtOldUserName, settxtOldUserName] = React.useState("");
  const [txtNewUserName, settxtNewUserName] = React.useState("");
  const [txtConformUserName, settxtConformUserName] = React.useState("");

  const { showNoteAlert } = useNoteAlert();
  const [showerrorBorder, setshowerrorBorder] = React.useState(false);
  const { userId, companyId } = useAuth();
  const histroy = useNavigate();
  useEffect(() => {
    var data = {
      UserID: userId,
      CompanyID: companyId,
    };
    axiosInstance
      .post("changeUsername/ChangeUser_Load", data)
      .then((response) => {
        if (response.data != "") {
          if (response.data != null) {
            settxtOldUserName(response.data);
          }
        }
      })
      .catch((error) => console.log(error.message));
  }, []);

  const handleNavigation = () => {
    histroy("/myaccount");
  };
  const SubmitClick = () => {
    //  document.getElementById("btnSubmit").disabled = true;
    setshowerrorBorder(false);
    document.getElementById("divInvalidChar").style.display = "none";
    document.getElementById("divUserName").style.display = "none";
    var data = {
      OldUserName: txtOldUserName,
      NewUserName: txtNewUserName,
      ConformUserName: txtConformUserName,
      UserID: userId,
      CompanyID: companyId,
    };
    if (txtOldUserName == "") {
      showNoteAlert(CHANGEUSERNAME.EMPTYOLDUSERNAME, "PLEASE NOTE", true, () => {
        $("#currnetLoginname").focus();
      });
      return false;
    }
    if (txtNewUserName == "") {
      showNoteAlert(CHANGEUSERNAME.EMPTYUSERNAME, "PLEASE NOTE", true, () => {
        $("#newLoginname").focus();
      });
      return false;
    }
    if (txtConformUserName == "") {
      showNoteAlert(CHANGEUSERNAME.EMPTYCONFIRMUSERNAME, "PLEASE NOTE", true, () => {
        $("#confirmLoginname").focus();
      });
      return false;
    }

    if (txtNewUserName != txtConformUserName) {
      showNoteAlert(CHANGEUSERNAME.USERNAMEDNOTMATCH, "PLEASE NOTE", true, () => {
        $("#newLoginname").focus();
      });

      return false;
    }

    if (txtNewUserName.length < 6 || txtNewUserName.length > 12) {
      setshowerrorBorder(!showerrorBorder);
      document.getElementById("divInvalidChar").style.display = "block";
      var focusID = document.getElementById("newLoginname");
      focusID.focus();
      return false;
    }

    axiosInstance
      .post("changeUsername/btnChangeUser_Click", data)
      .then((response) => {
        if (response.data != "") {
          if (response.data != "Success") {
            if (response.data == "Invalid current UserName") {
              setshowerrorBorder(!showerrorBorder);
              document.getElementById("divUserName").style.display = "block";
            } else {
              showNoteAlert(response.data);
            }
          } else {
            document.getElementById("divUpdateSuccess").style.display = "block";
            document.getElementById("divShowDetails").style.display = "none";
          }
        }
      })
      .catch((error) => console.log(error.message));
  };

  return (
    <>
      <BreadCrumb
        data={[
          { name: "My Account", url: PAGES.MYACCOUNT },
          { name: "Change Username", url: PAGES.CHANGE_USERNAME },
        ]}
      />
      <section className="myAccount-section">
        <div className="container-fluid container-lg" id="divShowDetails" style={{ display: "block" }}>
          <div className="row">
            <div className="col-lg-12">
              <div className="acc-header py-3">
                <div className="myaccount-address myAccount-header">
                  <h1 className="myaccount-title">Change Username</h1>
                </div>
              </div>
            </div>
            <div className="col-sm-8 col-md-6">
              <div className="row">
                <div className="col-lg-12 mt-3">
                  <div className="passwordInstructions">
                    <span className="wes-info-cc"></span>
                    <p>You will need to enter between 6-12 characters in your user name</p>
                  </div>
                </div>
                <form className="mt-3">
                  <div className="col-md-12 col-lg-12">
                    <div className="floating-input changedPwd mb-3">
                      <input
                        id="currnetLoginname"
                        className="form-control form-input"
                        readOnly="readonly"
                        type="text"
                        placeholder=""
                        required=""
                        value={txtOldUserName}
                        onChange={(changeEvent) => settxtOldUserName(changeEvent.target.value)}
                        disabled="disabled"
                      />
                      <label for="currnetLoginname">Current Login Name</label>
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-12">
                    <div className="floating-input changedPwd mb-3">
                      <input
                        id="newLoginname"
                        className={
                          showerrorBorder ? "form-control form-input error-message" : "form-control form-input"
                        }
                        type="text"
                        placeholder=""
                        required=""
                        value={txtNewUserName}
                        onChange={(changeEvent) => settxtNewUserName(isAlphaNumericAnd_dot(changeEvent.target.value))}
                        maxLength="12"
                      />
                      <label for="newLoginname">New Login Name</label>
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-12">
                    <div className="floating-input changedPwd mb-3">
                      <input
                        id="confirmLoginname"
                        className={
                          showerrorBorder ? "form-control form-input error-message" : "form-control form-input"
                        }
                        type="text"
                        placeholder=""
                        required=""
                        value={txtConformUserName}
                        onChange={(changeEvent) =>
                          settxtConformUserName(isAlphaNumericAnd_dot(changeEvent.target.value))
                        }
                        maxLength="12"
                      />
                      <label for="confirmLoginname">Confirm New Login Name</label>
                    </div>
                  </div>
                  <div className="col-lg-12 mt-3" id="divInvalidChar" style={{ display: "none" }}>
                    <div
                      className="toast show pwd-error-toast w-100 mt-3"
                      role="alert"
                      aria-live="assertive"
                      aria-atomic="true"
                    >
                      <div className="toast-body fav-orderno-not d-flex align-content-center justify-content-between">
                        <div className="fav-ordernoNot-lft d-flex align-items-start justify-content-between">
                          <div>
                            <svg
                              width={47}
                              height={48}
                              viewBox="0 0 47 48"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect y={0.5} width={47} height={47} rx={23.5} fill="#F82643" fillOpacity={0.2} />
                              <rect x={3} y={3.5} width={41} height={41} rx={20.5} fill="#F82643" />
                              <path
                                d="M23.5 21.375V25.75"
                                stroke="white"
                                strokeWidth={1.5}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M23.5 32.2339H18.1975C15.1613 32.2339 13.8925 30.0639 15.3625 27.4126L18.0925 22.4951L20.665 17.8751C22.2225 15.0664 24.7775 15.0664 26.335 17.8751L28.9075 22.5039L31.6375 27.4214C33.1075 30.0726 31.83 32.2426 28.8025 32.2426H23.5V32.2339Z"
                                stroke="white"
                                strokeWidth={1.5}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M23.4952 28.375H23.5031"
                                stroke="white"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                          <div className="pwd-ordernoNot-info">
                            <h5 className="fw-semibold">Invalid Character Entered</h5>
                            <p className="fw-medium col-fs-13 fs-14 m-0">Please Enter valid Username</p>
                          </div>
                        </div>
                        <div className="ct-close">
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="toast"
                            aria-label="Close"
                          ></button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 mt-3" id="divUserName" style={{ display: "none" }}>
                    <div
                      className="toast show fav-error-toast w-100 mt-3"
                      role="alert"
                      aria-live="assertive"
                      aria-atomic="true"
                    >
                      <div className="toast-body fav-orderno-not d-flex align-content-center justify-content-between">
                        <div className="fav-ordernoNot-lft d-flex align-items-start justify-content-between">
                          <div>
                            <svg
                              width={47}
                              height={47}
                              viewBox="0 0 47 47"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect width={47} height={47} rx={23.5} fill="#F8A026" fillOpacity={0.2} />
                              <rect x={3} y={3} width={41} height={41} rx={20.5} fill="#F8A026" />
                              <path
                                d="M23.5 20.875V25.25"
                                stroke="white"
                                strokeWidth={1.5}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M23.5 31.7339H18.1975C15.1613 31.7339 13.8925 29.5639 15.3625 26.9126L18.0925 21.9951L20.665 17.3751C22.2225 14.5664 24.7775 14.5664 26.335 17.3751L28.9075 22.0039L31.6375 26.9214C33.1075 29.5726 31.83 31.7426 28.8025 31.7426H23.5V31.7339Z"
                                stroke="white"
                                strokeWidth={1.5}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M23.4951 27.875H23.503"
                                stroke="white"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                          <div className="fav-ordernoNot-info pwd-ordernoNot-info">
                            <h5 className="fw-semibold">User Name Not Available</h5>
                            <p className="fw-medium col-fs-13 fs-14 m-0">
                              The username you entered is not available. Please try another one
                            </p>
                          </div>
                        </div>
                        <div className="ct-close">
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="toast"
                            aria-label="Close"
                          ></button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-12 mt-3">
                    <div className="accountBtns-list">
                      <div className="button-effect">
                        <a
                          className="btn btn-products theme-primary"
                          style={{ color: "white", fontWeight: "normal" }}
                          data-bs-dismiss="modal"
                          onClick={() => SubmitClick()}
                        >
                          {" "}
                          Update Username
                        </a>
                      </div>
                      {/* <Link to="/myaccount">Cancel</Link>
                       */}
                      <CancelButton
                        onClick={() => {
                          histroy(PAGES.MYACCOUNT);
                        }}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid container-lg" id="divUpdateSuccess" style={{ display: "none" }}>
          <div className="row">
            <div className="col-lg-12">
              <div className="pwd-success-section">
                <div className="row">
                  <div className="col-md-12 col-lg-6 offset-lg-3">
                    <div className="loginVerification-wrapper text-center">
                      <div className="loginVerification-wrapperTitle">
                        <svg
                          className="loginVerification-check"
                          width="60"
                          height="61"
                          viewBox="0 0 60 61"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M30 55.5C43.75 55.5 55 44.25 55 30.5C55 16.75 43.75 5.5 30 5.5C16.25 5.5 5 16.75 5 30.5C5 44.25 16.25 55.5 30 55.5Z"
                            stroke="#3BA429"
                            strokeWidth="3.375"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                          <path
                            d="M19.375 30.4998L26.45 37.5748L40.625 23.4248"
                            stroke="#3BA429"
                            strokeWidth="3.375"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        <h1 className="fw-semibold mt-4">Username Updated Successfully!</h1>
                        <p className="fs-14 fw-normal">
                          You current login name has been changed successfully. Use your new username to login.
                        </p>
                        <div className="button-effect loginPwd-updateBtn">
                          <form action={window.location.origin + "/api/Logout"} method="POST">
                            <div className="dropdown-myAccount-footer">
                              <button
                                type="submit"
                                className="btn btn-products btn-addcart"
                                style={{
                                  width: "200px",
                                  textAlign: "center",
                                  margin: "0 auto",
                                  fontSize: "14px",
                                }}
                              >
                                Back to Login
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
